module.exports = __webpack_public_path__ + "static/media/beauty and the beach.83fc00de.jpg";